import { useCallback, useState } from 'react'
import axios from 'axios'
import config from 'config'

const useSessionsList = () => {
  const [state, setState] = useState({
    isFetching: false,
    items: [],
    total: 0,
    error: null,
  })

  const setStartFetching = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: true,
    }))
  }, [setState])

  const setSuccessFetching = useCallback(
    (items, total) => {
      setState((s) => ({
        ...s,
        items: items,
        total: total,
        isFetching: false,
        error: null,
      }))
    },
    [setState]
  )

  const fetchSessions = useCallback(async () => {
    setStartFetching()

    const results = await axios.get(`${config.apiBaseUrl}sessions`)

    setSuccessFetching(results.data.body.items, results.data.body.total)
  }, [setStartFetching, setSuccessFetching])

  return {
    sessions: state.items,
    total: state.total,
    isFetching: state.isFetching,
    fetchSessions,
  }
}

export default useSessionsList
